<template>
  <div class="exam">
    <Header />
    <Nav />
    <div class="exam-container">
      <img src="../assets/exam/title.png" alt="">
      <div class="exam-person">
        <div class="exam-person-label">考试人</div>
        <div class="exam-person-value"><i></i><input type="text" placeholder="请输入考试人姓名"></div>
      </div>
      <div class="exam-remarks"><i>*</i>请确认考试人信息，此信息会展示在证书中，一旦确认不可修改</div>
      <div class="exam-rule">
        <p>考试规则：</p>
        <p>1.本测试为限时测试一旦开始不可停止，请合理安排答题时间</p>
        <p>2.测试完成后会在1-5个工作日内完成试卷的批阅/测试完成后即展示得分</p>
        <p>3.试卷批阅完毕公布得分后可再次访问此页面查看正确答案及解析</p>
        <p>4.本次考试为发证考试，公布得分后，满X分即可获得证书</p>
        <p>5.若考试未通过，可参与补考，若补考满X分可获得证书</p>
      </div>
      <div class="exam-btn" @click="gotopic">开始考试</div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from '@/components/Fixed.vue';
export default {
  name: "Exam",
  components: {
    Header,
    Nav,
    Footer,
    Fixed,
  },
  methods: {
    gotopic() {
      this.$router.push('/topic')
    }
  }
};
</script>

<style lang="less" scoped>
.exam {
  &-container {
    text-align: center;
    background: url(../assets/exam/bg.png) no-repeat right bottom;
    background-size: 100% auto;
    padding-top: 124px;
    padding-bottom: 121px;
    img {
      width: 478px;
      height: auto;
    }
  }
  &-person {
    margin: 0 auto;
    margin-top: 77px;
    width: 310px;
    height: 46px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #999999;
    display: flex;
    &-label {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      line-height: 46px;
      border-right: 1px solid #999999;
      width: 80px;
    }
    &-value {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        width: 10px;
        height: 10px;
        background: linear-gradient(180deg, #DC2D38 0%, #B6141A 100%);
        border-radius: 50%;
        margin-left: 29px;
        margin-right: 10px;
      }
      input {
        flex: 1;
      }
    }
  }
  &-remarks {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #202429;
    line-height: 17px;
    width: 310px;
    margin: 13px auto 0;
    word-break: keep-all;
    white-space: nowrap;
    i {
      color: #b6141a;
      font-style: normal;
    }
  }
  &-rule {
    width: 400px;
    margin: 0 auto;
    margin-top: 68px;
    text-align: left;
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202429;
      line-height: 27px;
    }
  }
  &-btn {
    width: 310px;
    height: 46px;
    background: linear-gradient(180deg, #DC2D38 0%, #B6141A 100%);
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 46px;
    margin: 100px auto 0;
    cursor: pointer;
  }
}
</style>